import github from "../assets/images/icons/github.svg";
import themeButtonOuter from "../assets/images/icons/theme-button-outer.svg";
import themeButtonInner from "../assets/images/icons/theme-button-inner.svg";
import settings from "../assets/images/icons/settings.svg";
import menu from "../assets/images/icons/menu.svg";
import close from "../assets/images/icons/close.svg";
import arrow from "../assets/images/icons/arrow.svg";
import exercise from "../assets/images/icons/exercise.svg";
import travel from "../assets/images/icons/travel.svg";
import grilling from "../assets/images/icons/grilling.svg";
import desktopPcs from "../assets/images/icons/desktop-pcs.svg";
import hiking from "../assets/images/icons/hiking.svg";
import quotes from "../assets/images/icons/quotes.svg";
import email from "../assets/images/icons/email.svg";
import phone from "../assets/images/icons/phone.svg";
import linkedin from "../assets/images/icons/linkedin.svg";
import pentagon from "../assets/images/icons/pentagon.svg";
import hexagon from "../assets/images/icons/hexagon.svg";
import dot from "../assets/images/icons/dot.svg";
import flag from "../assets/images/icons/flag.svg";
import toolBox from "../assets/images/icons/tool-box.svg";
import toolKit1 from "../assets/images/icons/tool-kit-1.svg";
import toolKit2 from "../assets/images/icons/tool-kit-2.svg";

import html from "../assets/images/logos/html.svg";
import css from "../assets/images/logos/css.svg";
import javascript from "../assets/images/logos/javascript.svg";
import sass from "../assets/images/logos/sass.svg";
import tailwind from "../assets/images/logos/tailwind.svg";
import tailwindLight from "../assets/images/logos/tailwind-light.svg";
import react from "../assets/images/logos/react.svg";
import vue from "../assets/images/logos/vue.svg";
import git from "../assets/images/logos/git.svg";
import gitLight from "../assets/images/logos/git-light.svg";
import api from "../assets/images/logos/api.svg";
import firebase from "../assets/images/logos/firebase.svg";
import storybook from "../assets/images/logos/storybook.svg";
import storybookLight from "../assets/images/logos/storybook-light.svg";
import storyblok from "../assets/images/logos/storyblok.svg";
import storyblokLight from "../assets/images/logos/storyblok-light.svg";

export const loadIcon = {
  github,
  themeButtonOuter,
  themeButtonInner,
  settings,
  menu,
  close,
  arrow,
  exercise,
  travel,
  grilling,
  desktopPcs,
  hiking,
  quotes,
  email,
  phone,
  linkedin,
  html,
  css,
  javascript,
  sass,
  tailwind,
  tailwindLight,
  react,
  vue,
  git,
  gitLight,
  api,
  firebase,
  pentagon,
  hexagon,
  dot,
  flag,
  storybook,
  storybookLight,
  storyblok,
  storyblokLight,
  toolBox,
  toolKit1,
  toolKit2,
};
